import Visualizador from "./Visualizador";

function NewBuro() {

    return (
        <Visualizador type={11} ></Visualizador>
    );
}

export default NewBuro;